import React, { useEffect, useState, useRef } from "react";
import TextArea from "../../components/CommentsInputArea/CommentsInput";
import GenericHeader from "../../components/GenericHeader/GenericHeader";
import Loader from "../../components/Loader/Loader";
import PopUp from "../../components/PopUp/PopUp";
import { Globals as OldGlobals } from "../../global/Globals";
import "../ReviewProposals/ReviewProposal.css";
import ReviewProposalFooter from "./ReviewProposalFooter";
import ReviewProposalHooks from "./ReviewProposalHooks";
import { useLocation } from "react-router-dom";
import axios from "./../../services/axiosInstance";
import NoResultsComponent from "../../components/NoResults/NoResult";
import { fetchDraftedCEEvalScores, fetchHalfPageBreif } from "../../services/api";
import { downloadFile } from "../../services/GenericAPI";
import { formatCurrency, formatDate } from "../../util/util";
import DocumentListItem from '../../components/HalfPage_Popup/DocumentListItem';
import CryptoUtils from "../../util/cryptoUtils";
import { useLanguage } from '../../context/Languagecontext';

const ReviewProposals = () => {
  const { Globals } = useLanguage();
  const [commentsInput, setCommentsInput] = useState("");
  const location = useLocation();

  const { selectedProposal, proposalId, proposalDetailId } = location.state;
  const [isSynopsisExpanded, setIsSynopsisExpanded] = useState(false);
  const [isLogLineExpanded, setIsLogLineExpanded] = useState(false);
  const [isepisodeStructureExpanded, setEpisodeStructureExpanded] = useState(false);
  const [iskeyTeamsExpanded, setKeyTeamsExpanded] = useState(false);
  const [isprojectStatusExpanded, setProjectStatusExpanded] = useState(false);
  const [isbrandIntegrationExpanded, setBrandIntegrationExpanded] = useState(false);
  const [iscastPresenterInfoExpanded, setCastPresenterInfoExpanded] = useState(false);
  const [islocationStudioInfoExpanded, setLocationStudioInfoExpanded] = useState(false);
  const [fileItems, setFileItems] = useState([]);
  const [criteria, setCriteria] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [draftedEvalDetails, setDraftedEvalDetails]=useState({})
  const [finalScore, setFinalScore] = useState(Globals.HALF_PAGE_BRIEF_DETAILS.NA);
  const inputRefs = useRef({});
  const [isExpand, setIsExpand] = useState(false);
  const [isEditorialExpanded, setIsEditorialExpanded] = useState(false);
  const [isCompanyProfileExpanded, setCompanyProfileExpanded] = useState(false);
  const [proposalData, setProposalData] = useState([]);
  const [contentData, setContentData] = useState([]);
  const [BreifData, setBreifData] = useState([]);
  const [loader, setLoader] = useState(true)
  const [proposalLoader, setProposalLoader] = useState(true)
  const [briefLoader, setBriefLoader] = useState(true)
  const [isDraft, setIsDraft]=useState(false);
  const handleCommentsInput = (value) => {
    setCommentsInput(value);
  };

  // fetch criteria data from database
  const fetchCriteriaData = async () => {
    // setLoader(true)
    const config = {
      headers: {
        "Content-Type": "application/json", // Set the Content-Type header
      },
    };
    let endPoint =
      OldGlobals.BASE_URL +
      OldGlobals.ENDPOINT.UNSOLICITED_CRITERIA_VALUE +
      proposalId;

    try {
      const response = await axios.get(endPoint, config);
      const criteriaData = response?.data?.content?.evaluationCriteria;
      setCriteria(criteriaData);
      setLoader(false)
      const initialValues = {};
      const initialTouched = {};
      const refs = {};

      criteriaData?.forEach((item) => {
        initialValues[item.criteriaId] = "";
        initialTouched[item.criteriaId] = false;
        refs[item.criteriaId] = React.createRef();
      });

      setInputValues(initialValues);
      setTouched(initialTouched);
      inputRefs.current = refs;
    } catch (error) {
      setLoader(false)
    }
  };

  // fetch proposal data from database for solicited/unsolicited
  const fetchProposalData = async () => {
    // setProposalLoader(true)
    const config = {
      headers: {
        "Content-Type": "application/json", // Set the Content-Type header
      },
    };
    const apiURL =  selectedProposal === 'solicited' ? 'CC_SOLICITED_HALF_SCREEN_MIN_DISPLAY' : 'CE_UNSOLICITED_HALF_SCREEN';
    const endPoint = `${OldGlobals.BASE_URL}${OldGlobals.ENDPOINT[apiURL]}proposalId=${proposalId}&roleId=${CryptoUtils.getFromLocalStorage('roleId')}&proposalDetailId=${proposalDetailId}`

    try {
      const response = await axios.get(endPoint, config);
      setProposalData(
        Array.isArray(response?.data?.content)
        ? response.data.content
        : [response?.data?.content]
      );
      setProposalLoader(false)

    } catch (error) {
      setProposalLoader(false)
    }
  };
 // fetch Brief data from database
const fetchBreifData = async () => {
  // setBriefLoader(true)
    try {
      const result = await fetchHalfPageBreif(
        OldGlobals.ENDPOINT.HALFPAGE_BRIEF,
       proposalId
      );
      const {
        createdByName,
        closingDate,
        countryName,
        productionTypeName,
        channelName,
        formatName,
        languageName,
        genreName,
        contentTypeName,
        clusterName,
        description,
        submissionRequirements,
        evalAndSelection,
        commisioningEditors,
        ceEvalDeadline,
        smEvalDeadline,
        briefTypeName,
        producers
      } = result.content;
      setContentData([
        { Description: description },
        { "Submission Requirements": submissionRequirements },
        { "Evaluation Process": evalAndSelection },
      ]);
      setBreifData([
        { name: Globals.BRIEF_DATA_KEYS["CREATED BY"], description: createdByName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.BRIEF_DATA_KEYS["CLOSING DATE"], description: formatDate(closingDate) },
        { name: Globals.BRIEF_DATA_KEYS["CHANNEL"], description: channelName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.BRIEF_DATA_KEYS["FORMAT"], description: formatName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.BRIEF_DATA_KEYS["COUNTRY"], description: countryName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.BRIEF_DATA_KEYS["PRODUCTION TYPE"], description: productionTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.BRIEF_DATA_KEYS["SCRIPTED / \n NON-SCRIPTED"], description: contentTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.BRIEF_DATA_KEYS["GENRE"], description: genreName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.BRIEF_DATA_KEYS["LANGUAGE"], description: languageName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.BRIEF_DATA_KEYS["CLUSTER"], description: clusterName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.BRIEF_DATA_KEYS["COMMISSIONING \n EDITIORS"], description: commisioningEditors?.length ? commisioningEditors.join(', ') : Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.BRIEF_TYPE, description: briefTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.CE_EVALUATION_DEADLINE, description: ceEvalDeadline && formatDate(ceEvalDeadline) || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.SM_EVALUATION_DEADLINE, description: smEvalDeadline && formatDate(smEvalDeadline) || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
        { name: Globals.BRIEF_DATA_KEYS.PRODUCERS, description: producers?.length > 0 && producers.join(', ') || Globals.HALF_PAGE_BRIEF_DETAILS.NA },
      ])
      setBriefLoader(false)
    } catch (error) {
      setBriefLoader(false)
      console.error("Error in App component:", error);
    }
  };

  useEffect(() => {
    if (proposalData?.[0]?.documents) {
      const allDocs = proposalData?.[0]?.documents;
      const orderedItems = [];
      const desiredOrder =
        selectedProposal === "solicited"
          ? ["LBMB", "PRSCH", "SHWRL", "CPRC", "RDOC"]
          : ["PSH", "VP"];
      desiredOrder.forEach((docFor) => {
        const foundDoc = allDocs.find((doc) => doc.documentFor === docFor);
        let heading = "";
        switch (docFor) {
          case "LBMB":
            heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.LBMB;
            break;
          case "PRSCH":
            heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.PRSCH;
            break;
          case "SHWRL":
            heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.SHWRL;
            break;
          case "CPRC":
            heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.CPRC;
            break;
          case "RDOC":
            heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.RDOC;
            break;
          case "PSH":
            heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.PRSCH;
            break;
          case "VP":
            heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.VP;
            break;
          default:
            heading = foundDoc?.documentType || "Document";
        }
        orderedItems.push({foundDoc, docFor, heading, isDownload: false});
      });
      setFileItems(orderedItems);
    } else {
      setFileItems([]);
    }
  }, [proposalData]);


  useEffect(() => {
    if (!proposalId) return;
    fetchData();
    if (selectedProposal === "solicited") {
      fetchBreifData();
    }
    if (proposalDetailId && selectedProposal) {
      fetchProposalData();
    }
  }, [proposalId, proposalDetailId, selectedProposal]);

  const[draftedComments, setDraftedComments]=useState("");
  //To get drafted CE Eval scrores on page load
  const fetchData = async () => {
      try {
        const response = await fetchDraftedCEEvalScores(proposalId, proposalDetailId);
        setLoader(false)
        console.log("response:", response);
        setDraftedEvalDetails(response?.data?.content?.evaluationCriterias);
        setCriteria(response?.data?.content?.evaluationCriterias);
        setDraftedComments(response?.data?.content?.comments)
        setCommentsInput(response?.data?.content?.comments);
        const data = response?.data?.content?.evaluationCriterias || [];
        let initialValues = {};
        data.forEach((item) => {
          initialValues[item.criteriaId] = item.gradeValue;
        });
        setInputValues(initialValues);
      } catch (error) {
        setLoader(false)
        console.error("Error fetching data:", error);
      }
    };
  useEffect(() => {
    fetchData();
  }, []);


  const handleInputChange = (criteriaId, value) => {
    setFinalScore("N/A");
    const regex = /^\d+(\.\d{0,2})?$/;
    if (/^0{2,}/.test(value)) {
      value = value.replace(/^0{2,}/, "0");
    }
    if (
      value === "" ||
      (Number(value) <= 10 && Number(value) >= 0 && regex.test(value))
    ) {
      setInputValues((prev) => ({ ...prev, [criteriaId]: value }));
      setErrors((prev) => ({ ...prev, [criteriaId]: "" }));
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const hooksProps = {
    commentsInput,
    proposalDetailId: proposalData?.[0]?.proposalDetailId || "",
    criteria,
    inputValues,
    selectedProposal,
    finalScore,
  };
  const {
    errors,
    loading,
    popUpState,
    openProposalReviewPopUp,
    setPopUpState,
    setErrors,
    validateFields,
    touched,
    setTouched,
  } = ReviewProposalHooks(hooksProps);
  const [activeIndexes, setActiveIndexes] = useState({
    brief_details: 0,
    propsal_details: 1,
  });
  const handleToggle = (category, index) => {
    setActiveIndexes((prevState) => ({
      ...prevState,
      [category]: prevState[category] === index ? null : index,
    }));
  };

  const toggleSynopsis = () => {
    setIsSynopsisExpanded(!isSynopsisExpanded);
  };

  const toggleLogLine = () => {
    setIsLogLineExpanded(!isLogLineExpanded);
  };

  const toggleEpisode = () => {
    setEpisodeStructureExpanded(!isepisodeStructureExpanded);
  };
  const toggleKeyteam = () => {
    setKeyTeamsExpanded(!iskeyTeamsExpanded);
  };
  const toggleProjectStatus = () => {
    setProjectStatusExpanded(!isprojectStatusExpanded);
  };
  const toggleBrand = () => {
    setBrandIntegrationExpanded(!isbrandIntegrationExpanded);
  };
  const toggleCast = () => {
    setCastPresenterInfoExpanded(!iscastPresenterInfoExpanded);
  };
  const toggleLocation = () => {
    setLocationStudioInfoExpanded(!islocationStudioInfoExpanded);
  };

  const toggleeditorial = () => {
    setIsEditorialExpanded(!isEditorialExpanded);
  };

  const toggleCompanyProfile = () => {
    setCompanyProfileExpanded(!isCompanyProfileExpanded);
  };

  const calculateAverage = () => {
    let hasError = false;
    const newErrors = {};

    criteria?.length > 0 &&
      criteria?.forEach((item) => {
        const error = validateFields(
          item.criteriaId,
          inputValues[item.criteriaId]
        );
        if (error) {
          newErrors[item.criteriaId] = error;
          hasError = true;
        }
      });

    setErrors(newErrors);
    setTouched((prev) => {
      const updatedTouched = { ...prev };
      criteria?.forEach((item) => {
        if (newErrors[item.criteriaId]) updatedTouched[item.criteriaId] = true;
      });
      return updatedTouched;
    });

    if (criteria?.length > 0 && !hasError) {
      let total = 0;
      let count = 0;
      criteria?.forEach((field) => {
        if (inputValues[field.criteriaId]) {
          total += Number(inputValues[field.criteriaId]);
          count++;
        }
      });
      let average = total / count;
      setFinalScore(Math.round(average) === NaN ? 0 : Math.round(average));
    } else {
      setFinalScore(0);
    }
  };

  const isFormValid = (type) => {
    return criteria?.every((item) => {
      const value = parseFloat(inputValues[item.criteriaId]);
      return (
        !isNaN(value) &&
        value >= 0 &&
        value <= 10 &&
        (type === "submit" ? finalScore !== "N/A" : true)
      );
    });
  };

  const isDraftFormValid=(type)=>{
    const isCriteriaValid = criteria?.some((item) => {
      const rawValue = inputValues[item.criteriaId];
      if (rawValue === undefined || rawValue === null || rawValue === "") {
        return false; // no value entered
      }
      const value = parseFloat(rawValue);
      // valid number between 0 and 10
      if (!isNaN(value) && value >= 0 && value <= 10) {
        // if submit, also check finalScore condition
        return type === "submit" ? finalScore !== "N/A" : true;
      }
      return false;
    });
    const isCommentFilled= commentsInput?.length>0?true:false;
    const res= isCommentFilled || isCriteriaValid;
    console.log("Res===>", res);
    return res;
  }

  const handleBlur = (id) => {
    const error = validateFields(id, inputValues[id]);
    setErrors((prev) => ({ ...prev, [id]: error }));
    setTouched((prev) => ({ ...prev, [id]: true }));
  };

  return (
    <div
      id="create-unsolicited-container"
      className="review-proposal-container"
    >
      {(loading) && (
        <Loader height={50} width={50} component="ReviewProposals" />
      )}
      <GenericHeader
        title={
          proposalData?.[0]
          ? `${Globals.REVIEW_PROPOSAL} #${proposalData[0].propRefNo} - ${proposalData[0].title || proposalData[0].projectTitle || ''}`.trim()
          : ''
        }
        onClose={() => openProposalReviewPopUp("Abort")}
      />
      {(loader) ? (
        <div
          className="NoResultsComponent"
          style={{ height: "80vh" }}
        >
          <Loader height={50} width={50} />
        </div>
      ):
      criteria?.length ? (
        <div id="" className="bottom-margin-zero">
          <div className="unsolicited-review-container">
            {selectedProposal === "solicited" && (
              <>
                <div className="review-proposal-unsolicated-briefs">
                  <div className={`Half ${isExpand ? "active" : ""}`}>
                    <div
                      className="brief-expandable-header"
                      onClick={() => {
                        setIsExpand(!isExpand);
                      }}
                    >
                      <label className="brief-accordion">{Globals.HALF_PAGE_BRIEF_DETAILS.BRIEF_DETAILS_HEADER}</label>
                      <img
                        className="arrow"
                        onClick={() => {
                          setIsExpand(!isExpand);
                        }}
                        src={
                          isExpand
                            ? OldGlobals.IMG.ARROW_UP
                            : OldGlobals.IMG.ARROW_DOWN
                        }
                        alt="toggle icon"
                      />
                    </div>
                    {isExpand && (
                      <>
                        <div className="details-ac">
                          {briefLoader ? (
                            <div
                              className="NoResultsComponent"
                              style={{ height: "80vh" }}
                            >
                              <Loader height={50} width={50} />
                            </div>
                          ) :
                          contentData?.length && BreifData?.length ? (
                            <div>
                              {contentData?.map(
                                (item, index) =>
                                  Object.values(item)[0] && (
                                    <div
                                      key={index}
                                      className="Half-Page-Content-Wrapper"
                                    >
                                      <div className="Half-Page-Desc-header1">
                                        { Globals.SOLICITED_BRIEFS[`${Object.keys(item)[0]}`]}
                                      </div>
                                      <p className="Half-Page-Description">
                                        {Object.values(item)[0]}
                                      </p>
                                    </div>
                                  )
                              )}
                              <div>
                                <div className="Half-Page-Form">
                                  {BreifData?.map((item, index) => (
                                    <div
                                      key={index}
                                      className="Half-Page-Form-Fields"
                                    >
                                      <div className="Half-Page-Form-fields-Bold">
                                        {item.name}
                                      </div>
                                      <div className="Half-Page-Form-Description">
                                        {item.description}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <NoResultsComponent
                              data={{
                                message: Globals.HALF_PAGE_MESSAGE,
                                img: OldGlobals.IMG.HALF_PAGE_ERROR,
                                submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                                className: "ErrorHeader",
                                subclassName: "SubError",
                                outerWrapper: "HalfPageWrapper",
                                button: "reload",
                              }}
                              handleReload={fetchData}
                            />
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="review-proposal-unsolicated-briefs">
                  <div className="subHeader" key={0}>
                    <div
                      draggable
                      onDragStart={(e) => e.preventDefault()}
                      onClick={() => handleToggle("propsal_details", 0)}
                      className="brief-expandable-header"
                    >
                      <label className="brief-accordion">
                        {Globals.REVIEW_PROPOSALS.PROPOSAL_DETAILS_TITLE}
                      </label>
                      <img
                        src={
                          activeIndexes["propsal_details"] === 0
                            ? OldGlobals.IMG.ARROW_UP
                            : OldGlobals.IMG.ARROW_DOWN
                        }
                        alt="toggle icon"
                        className="arrow"
                      />
                    </div>
                    {activeIndexes["propsal_details"] === 0 && (
                      <>
                      {proposalLoader?(
                            <div
                              className="NoResultsComponent"
                              style={{ height: "80vh" }}
                            >
                              <Loader height={50} width={50} />
                            </div>
                          ) :
                      proposalData?.length ?(<>
                        <div className="proposal-title">
                          <p className="text-content-company">
                            {proposalData?.[0]?.producerName}
                            <span className="text">{ Globals.HALFSCREEN.PRESENTS}</span>
                          </p>
                          <div className="proposal-title">
                            {proposalData[0]?.title ||
                              proposalData?.[0]?.projectTitle}
                          </div>
                        </div>
                        
                        <div className="proposal-container">
                          <div className="proposal-half-page-left">
                            <div className="proposal-heading">
                              {Globals.SOLICITED_PROPOSAL.LOGLINE}
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.logLine ? (
                                <>
                                  {proposalData[0]?.logLine?.length > 294 ? (
                                    <>
                                      {isLogLineExpanded
                                        ? proposalData[0]?.logLine
                                        : `${proposalData[0]?.logLine.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleLogLine}
                                        >
                                          {isLogLineExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.logLine
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>

                            <div className="proposal-heading">
                              {Globals.UNSOLICITED_PROPOSAL_HALF.SYNOPSIS}
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.synopsis ? (
                                <>
                                  {proposalData[0]?.synopsis?.length > 294 ? (
                                    <>
                                      {isSynopsisExpanded
                                        ? proposalData[0]?.synopsis
                                        : `${proposalData[0]?.synopsis.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleSynopsis}
                                        >
                                          {isSynopsisExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.synopsis
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>

                            <div className="unsolicated-heading">
                              {
                                Globals.UNSOLICITED_PROPOSAL_HALF
                                  .EPISODE_STRUCTURE
                              }
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.episodeStructure ? (
                                <>
                                  {proposalData[0]?.episodeStructure?.length >
                                  294 ? (
                                    <>
                                      {isepisodeStructureExpanded
                                        ? proposalData[0]?.episodeStructure
                                        : `${proposalData[0]?.episodeStructure.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleEpisode}
                                        >
                                          {isepisodeStructureExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.episodeStructure
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>

                            <div className="proposal-heading">
                              {Globals.SOLICITED_PROPOSAL.EDITORIAL}
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.editorialDetails ? (
                                <>
                                  {proposalData[0]?.editorialDetails?.length >
                                  294 ? (
                                    <>
                                      {isEditorialExpanded
                                        ? proposalData[0]?.editorialDetails
                                        : `${proposalData[0]?.editorialDetails.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleeditorial}
                                        >
                                          {isEditorialExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.editorialDetails
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>
                            <div className="proposal-section">
                              <div className="proposal-heading">
                                {Globals.SOLICITED_PROPOSAL.PRELIMINARY}
                              </div>
                              <p className="text-content">
                                {proposalData[0]?.currency}{" "}
                                {proposalData[0]?.targetBudget
                                  ? formatCurrency(proposalData[0]?.targetBudget)
                                  : ""}
                              </p>
                            </div>
                            <div className="unsolicated-heading">
                              {Globals.UNSOLICITED_PROPOSAL_HALF.LOCATION}
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.locationStudioInfo ? (
                                <>
                                  {proposalData[0]?.locationStudioInfo?.length >
                                  294 ? (
                                    <>
                                      {islocationStudioInfoExpanded
                                        ? proposalData[0]?.locationStudioInfo
                                        : `${proposalData[0]?.locationStudioInfo.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleLocation}
                                        >
                                          {islocationStudioInfoExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.locationStudioInfo
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>
                            <div className="unsolicated-heading">
                              {
                                Globals.UNSOLICITED_PROPOSAL_HALF
                                  .CAST_PRESENTER_INFO
                              }
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.castPresenterInfo ? (
                                <>
                                  {proposalData[0]?.castPresenterInfo?.length >
                                  294 ? (
                                    <>
                                      {iscastPresenterInfoExpanded
                                        ? proposalData[0]?.castPresenterInfo
                                        : `${proposalData[0]?.castPresenterInfo.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleCast}
                                        >
                                          {iscastPresenterInfoExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.castPresenterInfo
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>
                            <div className="unsolicated-heading">
                              {
                                Globals.UNSOLICITED_PROPOSAL_HALF
                                  .BRAND_INTEGRATION_OPPORTUNITIES
                              }
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.brandIntegration ? (
                                <>
                                  {proposalData[0]?.brandIntegration?.length >
                                  294 ? (
                                    <>
                                      {isbrandIntegrationExpanded
                                        ? proposalData[0]?.brandIntegration
                                        : `${proposalData[0]?.brandIntegration.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleBrand}
                                        >
                                          {isbrandIntegrationExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.brandIntegration
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>
                            <div className="proposal-section">
                              <div className="proposal-heading">
                                {Globals.SOLICITED_PROPOSAL.COMPANY}
                              </div>
                              <p className="text-content last">
                                {proposalData[0]?.keyTeams ? (
                                  <>
                                    {proposalData[0]?.keyTeams?.length > 294 ? (
                                      <>
                                        {isCompanyProfileExpanded
                                          ? proposalData[0]?.keyTeams
                                          : `${proposalData[0]?.keyTeams.substring(
                                              0,
                                              294
                                            )}...`}
                                        <div className="view">
                                          <span
                                            className="view-more"
                                            onClick={toggleCompanyProfile}
                                          >
                                            {isCompanyProfileExpanded
                                              ? "View Less"
                                              : "View More"}
                                          </span>
                                        </div>
                                      </>
                                    ) : (
                                      proposalData[0]?.keyTeams
                                    )}
                                  </>
                                ) : (
                                  Globals.HALF_PAGE_BRIEF_DETAILS.NA
                                )}
                              </p>
                            </div>
                          </div>
                          <img src={OldGlobals.IMG.LINE} alt="" />
                          <div className="proposal-right-content">
                            {fileItems?.length > 0 ? (
                              <div>
                                {fileItems.map(({foundDoc, docFor, heading}) => <DocumentListItem foundDoc={foundDoc} docFor={docFor} heading={heading}/>)} 
                              </div>
                            ) : (
                              <p>{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</p>
                            )}
                          </div>
                        </div> </>): (
                            <NoResultsComponent
                              data={{
                                message: Globals.HALF_PAGE_MESSAGE,
                                img: OldGlobals.IMG.HALF_PAGE_ERROR,
                                submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                                className: "ErrorHeader",
                                subclassName: "SubError",
                                outerWrapper: "HalfPageWrapper",
                                button: "reload",
                              }}
                              handleReload={fetchProposalData}
                            />
                          )}
                      </>
                    )}
                  </div>
                </div>
              </>
            )}

            {selectedProposal === "unSolicited" && (
              <div
                id="review-proposal-form"
                className="review-proposal-unsolicated-briefs"
              >
                <div id="review-proposal-form-content">
                  <div className="subHeader" key={0}>
                    <div
                      draggable
                      onDragStart={(e) => e.preventDefault()}
                      onClick={() => handleToggle("propsal_details", 0)}
                      className="brief-expandable-header"
                    >
                      <label className="brief-accordion">
                        {Globals.REVIEW_PROPOSALS.PROPOSAL_DETAILS_TITLE}
                      </label>
                      <img
                        src={
                          activeIndexes["propsal_details"] === 0
                            ? OldGlobals.IMG.ARROW_UP
                            : OldGlobals.IMG.ARROW_DOWN
                        }
                        alt="toggle icon"
                        className="arrow"
                      />
                    </div>
                    {activeIndexes["propsal_details"] === 0 && (
                      <div className="">
                      {proposalLoader? (
                            <div
                              className="NoResultsComponent"
                              style={{ height: "80vh" }}
                            >
                              <Loader height={50} width={50} />
                            </div>
                          ):
                       proposalData?.length ?<>
                        <div className="proposal-title">
                          <p className="text-content-company">
                            {proposalData?.[0]?.producerName}
                            <span className="text">{" presents"}</span>
                          </p>
                          <div className="proposal-title">
                            {proposalData[0]?.title ||
                              proposalData?.[0]?.projectTitle}
                          </div>
                        </div>

                        <div className="proposal-container">
                          <div className="proposal-half-page-left">
                            <div className="unsolicated-proposal-text-width">
                              <div className="unsolicated-heading">
                                {Globals.UNSOLICITED_PROPOSAL_HALF.COUNTRY}{" "}
                              </div>
                              <div className="text-content-unsolicated-width">
                                {proposalData[0]?.countryName}
                              </div>
                            </div>

                            <div className="unsolicated-proposal-text-width">
                              <div className="unsolicated-heading">
                                {Globals.UNSOLICITED_PROPOSAL_HALF.SCRIPTED}{" "}
                              </div>
                              <div className="text-content-unsolicated-width">
                                {proposalData[0]?.contentName}
                              </div>
                            </div>

                            <div className="unsolicated-proposal-text-width">
                              <div className="unsolicated-heading">
                                {Globals.UNSOLICITED_PROPOSAL_HALF.CLUSTER}{" "}
                              </div>
                              <div className="text-content-unsolicated-width">
                                {proposalData[0]?.clusterName}
                              </div>
                            </div>
                            <div className="unsolicated-proposal-text-width">
                              <div className="unsolicated-heading">
                                {Globals.UNSOLICITED_PROPOSAL_HALF.GENRE}{" "}
                              </div>
                              <div className="text-content-unsolicated-width">
                                {proposalData[0]?.genreName}
                              </div>
                            </div>
                            <div className="unsolicated-proposal-text-width">
                              <div className="unsolicated-heading">
                                {Globals.UNSOLICITED_PROPOSAL_HALF.CHANNEL}{" "}
                              </div>
                              <div className="text-content-unsolicated-width">
                                {proposalData[0]?.channelName}
                              </div>
                            </div>
                            {proposalData[0]?.othergenre && (
                              <div className="unsolicated-proposal-text-width">
                                <div className="unsolicated-heading">
                                  {Globals.UNSOLICITED_PROPOSAL_HALF.OTHERGENRE}{" "}
                                </div>
                                <div className="text-content-unsolicated-width">
                                  {proposalData[0]?.othergenre}
                                </div>
                              </div>
                            )}

                            <div className="unsolicated-proposal-text-width">
                              <div className="unsolicated-heading">
                                {Globals.UNSOLICITED_PROPOSAL_HALF.LANGUAGE}{" "}
                              </div>
                              <div className="text-content-unsolicated-width">
                                {proposalData[0]?.languageName}
                              </div>
                            </div>

                            <div className="unsolicated-proposal-text-width">
                              <div className="unsolicated-heading">
                                {
                                  Globals.UNSOLICITED_PROPOSAL_HALF
                                    .PRODUCTIONTYPE
                                }{" "}
                              </div>
                              <div className="text-content-unsolicated-width">
                                {proposalData[0]?.productionTypeName}
                              </div>
                            </div>

                            <div className="unsolicated-proposal-text-width">
                              <div className="unsolicated-heading">
                                {
                                  Globals.UNSOLICITED_PROPOSAL_HALF
                                    .TARGET_AUDIENCE
                                }{" "}
                              </div>
                              <div className="text-content-unsolicated-width">
                                {proposalData[0]?.targetAudienceName}
                              </div>
                            </div>

                            <div className="unsolicated-proposal-text-width">
                              <div className="unsolicated-heading">
                                {Globals.UNSOLICITED_PROPOSAL_HALF.FORMAT}{" "}
                              </div>
                              <div className="text-content-unsolicated-width">
                                {proposalData[0]?.formatName}
                              </div>
                            </div>

                            {proposalData[0]?.noOfEpisodes ? (
                              <>
                                <div className="unsolicated-proposal-text-width">
                                  <div className="unsolicated-heading">
                                    {
                                      Globals.UNSOLICITED_PROPOSAL_HALF
                                        .NOOFEPISODES
                                    }{" "}
                                  </div>
                                  <div className="text-content-unsolicated-width">
                                    {proposalData[0]?.noOfEpisodes}
                                  </div>
                                </div>
                                <div className="unsolicated-proposal-text-width">
                                  <div className="unsolicated-heading">
                                    {
                                      Globals.UNSOLICITED_PROPOSAL_HALF
                                        .EPDURATION
                                    }{" "}
                                  </div>
                                  <div className="text-content-unsolicated-width">
                                    {proposalData[0]?.episodeDuration}
                                  </div>
                                </div>
                                <div className="unsolicated-proposal-text-width">
                                  <div className="unsolicated-heading">
                                    {
                                      Globals.UNSOLICITED_PROPOSAL_HALF
                                        .TOTALEPDURATION
                                    }{" "}
                                  </div>
                                  <div className="text-content-unsolicated-width">
                                    {proposalData[0]?.totalEpisodesDuration ||
                                      proposalData[0]?.noOfEpisodes *
                                        proposalData[0]?.episodeDuration}
                                  </div>
                                </div>
                              </>
                            ) : (
                              <div className="unsolicated-proposal-text-width">
                                <div className="unsolicated-heading">
                                  {
                                    Globals.UNSOLICITED_PROPOSAL_HALF
                                      .DURATIONINMINS
                                  }{" "}
                                </div>
                                <div className="text-content-unsolicated-width">
                                  {proposalData[0]?.episodeDuration}
                                </div>
                              </div>
                            )}

                            <div className="proposal-heading">
                              {Globals.UNSOLICITED_PROPOSAL_HALF.SYNOPSIS}
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.synopsis ? (
                                <>
                                  {proposalData[0]?.synopsis?.length > 294 ? (
                                    <>
                                      {isSynopsisExpanded
                                        ? proposalData[0]?.synopsis
                                        : `${proposalData[0]?.synopsis.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleSynopsis}
                                        >
                                          {isSynopsisExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.synopsis
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>
                            <div className="proposal-heading">
                              {Globals.SOLICITED_PROPOSAL.LOGLINE}
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.logLine ? (
                                <>
                                  {proposalData[0]?.logLine?.length > 294 ? (
                                    <>
                                      {isLogLineExpanded
                                        ? proposalData[0]?.logLine
                                        : `${proposalData[0]?.logLine.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleLogLine}
                                        >
                                          {isLogLineExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.logLine
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>

                            <div className="unsolicated-heading">
                              {Globals.UNSOLICITED_PROPOSAL_HALF.TARGET_BUDGET}{" "}
                            </div>
                            <div className="text-content bottom-spacing">
                              {proposalData[0]?.currency}{" "}
                              {formatCurrency(proposalData[0]?.targetBudget)}
                            </div>
                            {/* </div> */}

                            <div className="unsolicated-heading">
                              {
                                Globals.UNSOLICITED_PROPOSAL_HALF
                                  .EPISODE_STRUCTURE
                              }
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.episodeStructure ? (
                                <>
                                  {proposalData[0]?.episodeStructure?.length >
                                  294 ? (
                                    <>
                                      {isepisodeStructureExpanded
                                        ? proposalData[0]?.episodeStructure
                                        : `${proposalData[0]?.episodeStructure.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleEpisode}
                                        >
                                          {isepisodeStructureExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.episodeStructure
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>

                            <div className="unsolicated-heading">
                              {Globals.UNSOLICITED_PROPOSAL_HALF.LOCATION}
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.locationStudioInfo ? (
                                <>
                                  {proposalData[0]?.locationStudioInfo?.length >
                                  294 ? (
                                    <>
                                      {islocationStudioInfoExpanded
                                        ? proposalData[0]?.locationStudioInfo
                                        : `${proposalData[0]?.locationStudioInfo.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleLocation}
                                        >
                                          {islocationStudioInfoExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.locationStudioInfo
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>

                            <div className="unsolicated-heading">
                              {
                                Globals.UNSOLICITED_PROPOSAL_HALF
                                  .CAST_PRESENTER_INFO
                              }
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.castPresenterInfo ? (
                                <>
                                  {proposalData[0]?.castPresenterInfo?.length >
                                  294 ? (
                                    <>
                                      {iscastPresenterInfoExpanded
                                        ? proposalData[0]?.castPresenterInfo
                                        : `${proposalData[0]?.castPresenterInfo.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleCast}
                                        >
                                          {iscastPresenterInfoExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.castPresenterInfo
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>

                            <div className="unsolicated-heading">
                              {
                                Globals.UNSOLICITED_PROPOSAL_HALF
                                  .BRAND_INTEGRATION_OPPORTUNITIES
                              }
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.brandIntegration ? (
                                <>
                                  {proposalData[0]?.brandIntegration?.length >
                                  294 ? (
                                    <>
                                      {isbrandIntegrationExpanded
                                        ? proposalData[0]?.brandIntegration
                                        : `${proposalData[0]?.brandIntegration.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleBrand}
                                        >
                                          {isbrandIntegrationExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.brandIntegration
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>

                            <div className="unsolicated-heading">
                              {Globals.UNSOLICITED_PROPOSAL_HALF.PROJECT_STATUS}
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.synopsis ? (
                                <>
                                  {proposalData[0]?.projectStatus?.length >
                                  294 ? (
                                    <>
                                      {isprojectStatusExpanded
                                        ? proposalData[0]?.projectStatus
                                        : `${proposalData[0]?.projectStatus.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleProjectStatus}
                                        >
                                          {isprojectStatusExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.projectStatus
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>

                            <div className="unsolicated-heading">
                              {Globals.UNSOLICITED_PROPOSAL_HALF.KEY_TEAM}
                            </div>
                            <p className="text-content">
                              {proposalData[0]?.keyTeams ? (
                                <>
                                  {proposalData[0]?.keyTeams?.length > 294 ? (
                                    <>
                                      {iskeyTeamsExpanded
                                        ? proposalData[0]?.keyTeams
                                        : `${proposalData[0]?.keyTeams.substring(
                                            0,
                                            294
                                          )}...`}
                                      <div className="view">
                                        <span
                                          className="view-more"
                                          onClick={toggleKeyteam}
                                        >
                                          {iskeyTeamsExpanded
                                            ? "View Less"
                                            : "View More"}
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    proposalData[0]?.keyTeams
                                  )}
                                </>
                              ) : (
                                Globals.HALF_PAGE_BRIEF_DETAILS.NA
                              )}
                            </p>
                            {proposalData[0]?.artistName && (
                              <div className="unsolicated-proposal-text-width">
                                <div className="unsolicated-heading">
                                  {
                                    Globals.UNSOLICITED_PROPOSAL_HALF
                                      .ARTIST_NAME
                                  }{" "}
                                </div>
                                <div className="text-content-unsolicated-width">
                                  {proposalData[0]?.artistName}
                                </div>
                              </div>
                            )}

                            {proposalData[0]?.songName && (
                              <div className="unsolicated-proposal-text-width">
                                <div className="unsolicated-heading">
                                  {Globals.UNSOLICITED_PROPOSAL_HALF.SONG_NAME}{" "}
                                </div>
                                <div className="text-content-unsolicated-width">
                                  {proposalData[0]?.songName}
                                </div>
                              </div>
                            )}

                            <div className="unsolicated-heading">
                              {
                                Globals.UNSOLICITED_PROPOSAL_HALF
                                  .REFERENCE_LINKS
                              }
                            </div>
                            <div className="text-content">
                              {proposalData[0]?.referenceLinks &&
                                proposalData[0].referenceLinks
                                  .split(",")
                                  .map((link, index) => {
                                    const trimmedLink = link.trim();
                                    const linkVariableName = `Reference Link ${
                                      index + 1
                                    }`;

                                    return (
                                      <span key={index} className="refflink">
                                        <a
                                          //href={trimmedLink}
                                          href={
                                            trimmedLink.startsWith("http://") ||
                                            trimmedLink.startsWith("https://")
                                              ? trimmedLink
                                              : `http://${trimmedLink}`
                                          }
                                          alt={linkVariableName}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="link-value"
                                        >
                                          {linkVariableName}
                                        </a>
                                        {index <
                                          proposalData[0].referenceLinks.split(
                                            ","
                                          )?.length -
                                            1 && (
                                          <span className="separator">, </span>
                                        )}
                                      </span>
                                    );
                                  })}
                            </div>
                          </div>
                          <img src={OldGlobals.IMG.LINE} alt="" />
                          <div className="proposal-right-content">
                            {fileItems?.length > 0 ? (
                              <div>
                              {fileItems.map(({foundDoc, docFor, heading}) => <DocumentListItem foundDoc={foundDoc} docFor={docFor} heading={heading}/>)} 
                            </div>
                            ) : (
                              <p>{Globals.HALF_PAGE_BRIEF_DETAILS.NA}</p>
                            )}
                          </div>
                        </div></>: (
                            <NoResultsComponent
                              data={{
                                message: Globals.HALF_PAGE_MESSAGE,
                                img: OldGlobals.IMG.HALF_PAGE_ERROR,
                                submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                                className: "ErrorHeader",
                                subclassName: "SubError",
                                outerWrapper: "HalfPageWrapper",
                                button: "reload",
                              }}
                              handleReload={fetchProposalData}
                            />
                          )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div id="artist-details-form" className="review-proposal-form">
              <div className="review-proposal-subbranch">
                <div
                  id="artist-details-title"
                  className="reviewproposal-basic-info"
                >
                  {Globals.REVIEW_PROPOSALS.EVALUATION_TITLE}
                </div>
                <div className="review-proposal-subheading">
                  <div id="" className="instruction_for_evalution">
                    {Globals.REVIEW_PROPOSALS.INSTRUCTION_FOR_EVALUATION}
                  </div>

                  <div className="">
                    <div id="" className="instruction_for_evalution_title">
                      {Globals.REVIEW_PROPOSALS.INSTRUCTION_BULLET_TITLE}
                    </div>
                    <ul className="ul-reviewproposal">
                      <li>{Globals.REVIEW_PROPOSALS.INSTRUCTION_BULLET_0}</li>
                      <li>{Globals.REVIEW_PROPOSALS.INSTRUCTION_BULLET_1}</li>
                      <li>{Globals.REVIEW_PROPOSALS.INSTRUCTION_BULLET_2}</li>
                    </ul>
                    <div id="" className="instruction_for_evalution_title">
                      {Globals.REVIEW_PROPOSALS.INSTRUCTION_END_TITLE}
                    </div>
                  </div>
                </div>
                <div className="vertical_line"></div>
                <div className="evaluation_row_content grid-container">
                  {criteria?.map((inputs, index) => {
                    return (
                      <div className="title-holder review-title-holder ">
                        <div id="" className="evaluation_title">
                          {inputs.criteriaName}
                          <span id="mandatory" class="mandatory">
                            *
                          </span>
                        </div>
                        <input
                          type="text"
                          placeholder={Globals.ADD_NEW_CLUSTER.SCORE_PLACEHOLDER}
                          value={inputValues[inputs.criteriaId] || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                              handleInputChange(inputs.criteriaId, value);
                            }
                          }}
                          onBlur={(e) => {
                            handleBlur(inputs.criteriaId);
                          }}
                          required
                        />
                        {touched[inputs.criteriaId] &&
                          errors[inputs.criteriaId] && (
                            <div className="validation_error">
                              {errors[inputs.criteriaId]}
                            </div>
                          )}
                      </div>
                    );
                  })}
                </div>
                <div className="calculate_btn">
                  <button
                    id="register-calculate-btn"
                    disabled={!isFormValid()}
                    className={"calculate-btn-active"}
                    onClick={calculateAverage}
                  >
                    {Globals.REVIEW_PROPOSALS.CALCULATE_FINAL_SCORE}
                  </button>
                </div>

                <div className="final_score">
                  <label id="" className="final_score_title">
                    {Globals.REVIEW_PROPOSALS.FINAL_SCORE_TITLE}
                  </label>
                  <br />
                  <div>{finalScore === NaN ? 0 : finalScore}</div>
                </div>

                <div id="comments" className="comments">
                  <div id="comments_section" className="comments_label">
                    {Globals.REVIEW_PROPOSALS.COMMENTS_TITLE}
                  </div>
                  <span tabIndex={6}>
                    <TextArea
                      value={commentsInput || draftedComments}
                      textAreaInput={handleCommentsInput}
                      className={
                        (commentsInput && commentsInput?.length > 0 || draftedComments && draftedComments?.length >0)
                          ? "hightlight"
                          : ""
                      }
                      classNameCharcount={"reviewproposal-charcount"}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <ReviewProposalFooter
            validate={!isFormValid("submit")}
            onSubmit={() => openProposalReviewPopUp("Submit")}
            onCancelCreate={() => openProposalReviewPopUp("Abort")}
            validateDraft={!isDraftFormValid("Draft")}
            onDraft={()=>openProposalReviewPopUp("Draft")}
          />
        </div>
      ):(
      <NoResultsComponent
        data={{
          message: Globals.HALF_PAGE_MESSAGE,
          img: OldGlobals.IMG.HALF_PAGE_ERROR,
          submessage: Globals.HALF_PAGE_SUB_MESSAGE,
          className: "ErrorHeader",
          subclassName: "SubError",
          outerWrapper: "HalfPageWrapper",
          button: "reload",
        }}
        handleReload={fetchCriteriaData}
      />
    )}
    {popUpState?.open && (
            <PopUp
              onClose={() => {setPopUpState({ open: false });}}
              text={popUpState.text || ""}
              title={popUpState.title || ""}
              negativeAction={popUpState.negativeAction}
              normalAction={popUpState.normalAction}
              negativeActionText={popUpState.negativeActionText}
              normalActionText={popUpState.normalActionText}
              remove_cancel_btn={popUpState.remove_cancel_btn}
            />
          )}
    </div>
  );
};
export default ReviewProposals;